import { useSelector } from 'react-redux';
import { getGameCondition } from '../selectors';

export const useGameCondition = () => useSelector(getGameCondition);
